/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** VerificationStatus */
export enum VerificationStatus {
  NotStarted = 'notStarted',
  Verified = 'verified',
  UnVerified = 'unVerified',
  ManualVerificationRequired = 'manualVerificationRequired',
}

/** UploadSessionStatus */
export enum UploadSessionStatus {
  Prepared = 'prepared',
  Uploaded = 'uploaded',
  Committed = 'committed',
}

/** SyndicationStatus */
export enum SyndicationStatus {
  NotStarted = 'notStarted',
  NotPostedAndBlocked = 'notPostedAndBlocked',
  NotPostedAndInvalidData = 'notPostedAndInvalidData',
  NotPostedAndUnpaidNotAllowed = 'notPostedAndUnpaidNotAllowed',
  NotPostedAndRestrictedArea = 'notPostedAndRestrictedArea',
  NotPostedAndDuplicate = 'notPostedAndDuplicate',
  Posted = 'posted',
  Unknown = 'unknown',
}

/** ReportType */
export enum ReportType {
  Criminal = 'criminal',
  Credit = 'credit',
  Eviction = 'eviction',
}

/** ReportStatus */
export enum ReportStatus {
  NotRequested = 'notRequested',
  Requested = 'requested',
  Available = 'available',
  Failed = 'failed',
}

/** RentalApplicationStage */
export enum RentalApplicationStage {
  Draft = 'draft',
  Submitted = 'submitted',
  Screened = 'screened',
  Decided = 'decided',
}

/** RentalApplicationScreeningSummary */
export enum RentalApplicationScreeningSummary {
  ScreeningNotCompleted = 'screeningNotCompleted',
  ScreeningCompleted = 'screeningCompleted',
  ReportsRequested = 'reportsRequested',
  ReportsAvailable = 'reportsAvailable',
}

/** RentalApplicationNeedsKind */
export enum RentalApplicationNeedsKind {
  DecisionOverdue = 'decisionOverdue',
  ReadyToConvert = 'readyToConvert',
  ReadyToApprove = 'readyToApprove',
  MissingDocs = 'missingDocs',
  AwaitingScreening = 'awaitingScreening',
  Unpaid = 'unpaid',
  PausedForInfo = 'pausedForInfo',
}

/** RentalApplicationFileKind */
export enum RentalApplicationFileKind {
  Other = 'other',
  PayStub = 'payStub',
  GovernmentId = 'governmentId',
  BankStatement = 'bankStatement',
  TaxReturn = 'taxReturn',
  OfferLetter = 'offerLetter',
  ReferenceLetter = 'referenceLetter',
  EmploymentVerification = 'employmentVerification',
}

/** PetGender */
export enum PetGender {
  Male = 'male',
  Female = 'female',
}

/** PaymentStatus */
export enum PaymentStatus {
  Unpaid = 'unpaid',
  IntentCreated = 'intentCreated',
  Paid = 'paid',
  Failed = 'failed',
  Refunded = 'refunded',
  Skipped = 'skipped',
  NotRequired = 'notRequired',
}

/** OfflinePaymentReason */
export enum OfflinePaymentReason {
  PartialPayment = 'partialPayment',
  Discount = 'discount',
  Overpayment = 'overpayment',
  Other = 'other',
}

/** MaritalStatus */
export enum MaritalStatus {
  Single = 'single',
  Married = 'married',
  Divorced = 'divorced',
  Widowed = 'widowed',
}

/** LandlordVerificationStatus */
export enum LandlordVerificationStatus {
  NotRequested = 'notRequested',
  Pending = 'pending',
  Verified = 'verified',
  Declined = 'declined',
  Rejected = 'rejected',
  Expired = 'expired',
}

/** InsightTone */
export enum InsightTone {
  Success = 'success',
  Warning = 'warning',
  Info = 'info',
}

/** InfoUpdateRequestStatus */
export enum InfoUpdateRequestStatus {
  Pending = 'pending',
  Completed = 'completed',
  Expired = 'expired',
}

/** GenieTakeTone */
export enum GenieTakeTone {
  Approve = 'approve',
  Caution = 'caution',
  Decline = 'decline',
  Undetermined = 'undetermined',
}

/** GenieTakeRelatedCard */
export enum GenieTakeRelatedCard {
  Employment = 'employment',
  RentalHistory = 'rentalHistory',
  Screening = 'screening',
  Documents = 'documents',
  CoApplicants = 'coApplicants',
  Questions = 'questions',
  DesiredUnit = 'desiredUnit',
}

/** GenieTakeBulletTone */
export enum GenieTakeBulletTone {
  Positive = 'positive',
  Caution = 'caution',
  Critical = 'critical',
}

/** GenieLandlordVerificationTone */
export enum GenieLandlordVerificationTone {
  Positive = 'positive',
  Warning = 'warning',
  Critical = 'critical',
  Muted = 'muted',
}

/** Gender */
export enum Gender {
  Male = 'male',
  Female = 'female',
  Other = 'other',
  PreferNotToSay = 'preferNotToSay',
}

/** FileCategory */
export enum FileCategory {
  Unknown = 'unknown',
  Company = 'company',
  Property = 'property',
  Lease = 'lease',
  Listing = 'listing',
  Association = 'association',
  RentalApplication = 'rentalApplication',
  MaintenanceRequest = 'maintenanceRequest',
  WorkOrder = 'workOrder',
  Communication = 'communication',
  Chat = 'chat',
  Email = 'email',
  Announcement = 'announcement',
  Accounting = 'accounting',
  Onboarding = 'onboarding',
  TenantInsurance = 'tenantInsurance',
  Attachment = 'attachment',
  MagicDoor = 'magicDoor',
  OwnerPackage = 'ownerPackage',
}

/** ExternalTransactionType */
export enum ExternalTransactionType {
  Plaid = 'plaid',
  Stripe = 'stripe',
  Zelle = 'zelle',
  Offline = 'offline',
  MagicDoor = 'magicDoor',
}

/** CoApplicantStatus */
export enum CoApplicantStatus {
  Invited = 'invited',
  Draft = 'draft',
  Submitted = 'submitted',
}

/** ApplicationStatus */
export enum ApplicationStatus {
  Draft = 'draft',
  Submitted = 'submitted',
  Retracted = 'retracted',
}

/** ApplicationDecision */
export enum ApplicationDecision {
  NoDecision = 'noDecision',
  Approved = 'approved',
  Rejected = 'rejected',
  Ignored = 'ignored',
}

/** ActionQueueUrgency */
export enum ActionQueueUrgency {
  Critical = 'critical',
  Warning = 'warning',
  Normal = 'normal',
  Positive = 'positive',
}

/** ActionQueueApplicationDto */
export interface ActionQueueApplicationDto {
  id: string;
  firstName?: string;
  lastName?: string;
}

/** ActionQueueBucketDto */
export interface ActionQueueBucketDto {
  kind: RentalApplicationNeedsKind;
  /** @format int32 */
  count: number;
  urgency: ActionQueueUrgency;
  topApplications: ActionQueueApplicationDto[];
}

/** AddressDto */
export interface AddressDto {
  /**
   * @minLength 0
   * @maxLength 250
   */
  streetAddress1?: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  streetAddress2?: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  city?: string;
  /**
   * @minLength 0
   * @maxLength 25
   */
  state?: string;
  /**
   * @minLength 0
   * @maxLength 25
   */
  zipCode?: string;
  /**
   * @minLength 0
   * @maxLength 25
   */
  country?: string;
}

/** AnswerOptionDto */
export interface AnswerOptionDto {
  text: string;
  isSelected: boolean;
  isFreeformInput: boolean;
  freeformValue?: string;
  followUpQuestions?: FollowUpQuestionDto[];
}

/** CoApplicantDto */
export interface CoApplicantDto {
  id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  status: CoApplicantStatus;
  /** @format date-time */
  invitedAt: string;
  /** @format date-time */
  acceptedAt?: string;
  /** @format date-time */
  submittedAt?: string;
  linkedApplicationId: string;
  /** @format double */
  statedAnnualIncome?: number;
}

/** CommandCenterDto */
export interface CommandCenterDto {
  pipeline: PipelineDto;
  actionQueue: ActionQueueBucketDto[];
  velocity: VelocityDto;
  insights: PipelineInsightDto[];
}

/** CommitFileUploadDto */
export interface CommitFileUploadDto {
  /**
   * @minLength 0
   * @maxLength 512
   */
  description?: string;
  kind?: RentalApplicationFileKind;
  employmentId?: string;
  residentialHistoryId?: string;
}

/** ConvertedTenantDto */
export interface ConvertedTenantDto {
  id: string;
  active: boolean;
  firstName: string;
  lastName?: string;
  email?: string;
  phone?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  chatId?: string;
  language?: string;
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  emergencyContacts?: EmergencyContactDto[];
}

/** CreateFileUploadSessionDto */
export interface CreateFileUploadSessionDto {
  /**
   * @minLength 1
   * @maxLength 255
   */
  fileName: string;
}

/** CreateInfoUpdateRequestDto */
export interface CreateInfoUpdateRequestDto {
  /**
   * @minLength 0
   * @maxLength 2500
   */
  reason?: string;
}

/** CreateRentalApplicationDto */
export interface CreateRentalApplicationDto {
  /**
   * @minLength 0
   * @maxLength 250
   */
  firstName?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  lastName?: string;
  /**
   * A strict email address.
   * @minLength 3
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
}

/** DriverLicenseDto */
export interface DriverLicenseDto {
  /**
   * @minLength 1
   * @maxLength 50
   */
  number?: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  state?: string;
}

/** DriversLicenseDto */
export interface DriversLicenseDto {
  /**
   * @minLength 0
   * @maxLength 100
   */
  number?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  state?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  country?: string;
}

/** EmergencyContactDto */
export interface EmergencyContactDto {
  name: string;
  phone?: string;
  email?: string;
  relationship?: string;
}

/** FileUploadSessionDto */
export interface FileUploadSessionDto {
  id: string;
  companyId: string;
  category: FileCategory;
  fileName: string;
  status: UploadSessionStatus;
  allowedTypes: string[];
  /** @format int32 */
  minSize: number;
  /** @format int32 */
  maxSize: number;
  endpoint: string;
  method: string;
  fields: Record<string, string>;
  /** @format date-time */
  expires: string;
  storageKey: string;
  reference: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** FollowUpQuestionDto */
export interface FollowUpQuestionDto {
  text: string;
  isRequired: boolean;
  isMultiSelect: boolean;
  answers?: AnswerOptionDto[];
}

/** GenieTakeBulletDto */
export interface GenieTakeBulletDto {
  tone: GenieTakeBulletTone;
  headline: string;
  detail?: string;
  relatedCard?: GenieTakeRelatedCard;
}

/** GenieTakeCoApplicantsRollupDto */
export interface GenieTakeCoApplicantsRollupDto {
  /** @format int32 */
  count: number;
  /** @format int32 */
  acceptedCount: number;
  /** @format double */
  combinedIncomeMultiple?: number;
}

/** GenieTakeDto */
export interface GenieTakeDto {
  applicationId: string;
  tone: GenieTakeTone;
  recommendation: string;
  strengths: GenieTakeBulletDto[];
  concerns: GenieTakeBulletDto[];
  landlordVerification: GenieTakeLandlordVerificationRollupDto;
  coApplicants: GenieTakeCoApplicantsRollupDto;
  /** @format date-time */
  generatedAt: string;
}

/** GenieTakeLandlordVerificationRollupDto */
export interface GenieTakeLandlordVerificationRollupDto {
  /** @format int32 */
  verifiedCount: number;
  /** @format int32 */
  pendingCount: number;
  /** @format int32 */
  declinedCount: number;
  tone: GenieLandlordVerificationTone;
}

/** HotpadsSyndicationStatusDto */
export interface HotpadsSyndicationStatusDto {
  status: SyndicationStatus;
  url?: string;
}

/** IncomeInformationDto */
export interface IncomeInformationDto {
  /** @format double */
  annualIncome?: number;
}

/** InfoUpdateRequestDto */
export interface InfoUpdateRequestDto {
  id: string;
  reason?: string;
  status: InfoUpdateRequestStatus;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  expiresAt: string;
  /** @format date-time */
  completedAt?: string;
  requestedByUserId: string;
  requestedByUserType: string;
}

/** InfoUpdateRequestListDto */
export interface InfoUpdateRequestListDto {
  items: InfoUpdateRequestDto[];
}

/** InterestedUnitDto */
export interface InterestedUnitDto {
  interestId: string;
  unitId: string;
  unitName?: string;
  propertyId: string;
  portfolioId: string;
  propertyName?: string;
  address?: AddressDto;
  singleLineAddress?: string;
  displayName?: string;
  imageFileId?: string;
  /** @format double */
  rent?: number;
  /** @format double */
  requestedDeposit?: number;
  /** @format date */
  availableSince?: string;
}

/** InviteCoApplicantDto */
export interface InviteCoApplicantDto {
  /**
   * @minLength 1
   * @maxLength 250
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  lastName: string;
  /**
   * A strict email address.
   * @minLength 3
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /**
   * @minLength 0
   * @maxLength 2500
   */
  message?: string;
}

/** ManualAuthWebhookPayload */
export interface ManualAuthWebhookPayload {
  /** @format int32 */
  screeningRequestRenterId: number;
  status: string;
  detail?: string;
}

/** NeedsDto */
export interface NeedsDto {
  kinds: RentalApplicationNeedsKind[];
}

/** PipelineDto */
export interface PipelineDto {
  stages: PipelineStageDto[];
  /** @format int32 */
  activeCount: number;
}

/** PipelineInsightDto */
export interface PipelineInsightDto {
  key: string;
  tone: InsightTone;
  headline: string;
  detail: string;
}

/** PipelineStageDto */
export interface PipelineStageDto {
  key: RentalApplicationStage;
  /** @format int32 */
  count: number;
  /** @format int32 */
  oldestDays: number;
}

/** PostRealtorComLeadDto */
export interface PostRealtorComLeadDto {
  /** @minLength 1 */
  listingId: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  name: string;
  /**
   * A strict email address.
   * @minLength 3
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  phone?: string;
  /**
   * @minLength 0
   * @maxLength 4000
   */
  message?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  address?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  floorplanId?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  multifamilyPropertyId?: string;
}

/** RecordOfflinePaymentDto */
export interface RecordOfflinePaymentDto {
  /**
   * @minLength 0
   * @maxLength 1000
   */
  method?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  reference?: string;
  /**
   * @format double
   * @min 0.01
   * @max 999999999.99
   */
  amount?: number;
  reason?: OfflinePaymentReason;
}

/** RefundPaymentDto */
export interface RefundPaymentDto {
  /**
   * @format double
   * @min 1
   * @max 999999999.99
   */
  amount: number;
  /**
   * @minLength 1
   * @maxLength 500
   */
  reason?: string;
}

/** RentalApplicationCarDto */
export interface RentalApplicationCarDto {
  id: string;
  carMake?: string;
  model?: string;
  /** @format int32 */
  year?: number;
  licensePlate?: string;
  stateRegistration?: string;
  color?: string;
  comment?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** RentalApplicationCarUpsertDto */
export interface RentalApplicationCarUpsertDto {
  /**
   * @minLength 0
   * @maxLength 250
   */
  carMake?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  model?: string;
  /** @format int32 */
  year?: number;
  /**
   * @minLength 0
   * @maxLength 50
   */
  licensePlate?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  stateRegistration?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  color?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  comment?: string;
}

/** RentalApplicationCommentDto */
export interface RentalApplicationCommentDto {
  id: string;
  section: string;
  comment: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** RentalApplicationCommentUpsertDto */
export interface RentalApplicationCommentUpsertDto {
  /**
   * @minLength 1
   * @maxLength 100
   */
  section: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  comment: string;
}

/** RentalApplicationDto */
export interface RentalApplicationDto {
  id: string;
  companyId: string;
  password: string;
  status: ApplicationStatus;
  /** @format date-time */
  submittedAt?: string;
  /** @format date-time */
  magicDoorTermsAcceptedAt?: string;
  /** @format date-time */
  transunionTermsAcceptedAt?: string;
  bifurcatedScreeningRequired: boolean;
  /** @format date-time */
  bifurcatedScreeningAcceptedAt?: string;
  decision: ApplicationDecision;
  isQualifiedDraft: boolean;
  groupId?: string;
  tenantId?: string;
  leaseId?: string;
  chatId?: string;
  /** @format int32 */
  aiApplicationScore?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  permissionToTexting?: boolean;
  ssn?: string;
  /** @format date */
  dateOfBirth?: string;
  /** @format date */
  desiredMoveInDate?: string;
  maritalStatus?: MaritalStatus;
  driversLicense?: DriversLicenseDto;
  incomeInformation?: IncomeInformationDto;
  emergencyContact?: RentalApplicationEmergencyContactDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  showVerification: boolean;
  showPayment: boolean;
  canRequestReports: boolean;
  requestApplicantCompleteScreeningReadiness: RequestApplicantCompleteScreeningReadinessDto;
  employment: RentalApplicationEmploymentDto[];
  residentialHistory: RentalApplicationResidentialHistoryDto[];
  pets: RentalApplicationPetDto[];
  cars: RentalApplicationCarDto[];
  comments: RentalApplicationCommentDto[];
  files: RentalApplicationFileDto[];
  questions?: {
    general?: RentalApplicationQuestionItemDto[];
    employment?: RentalApplicationQuestionItemDto[];
  };
  screening?: RentalApplicationScreeningDto;
  payment?: RentalApplicationPaymentDto;
  reports: RentalApplicationReportDto[];
  coApplicants: CoApplicantDto[];
  interestedUnits: InterestedUnitDto[];
}

/** RentalApplicationEmergencyContactDto */
export interface RentalApplicationEmergencyContactDto {
  /**
   * @minLength 0
   * @maxLength 150
   */
  name?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /**
   * A strict email address.
   * @minLength 3
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  relationship?: string;
}

/** RentalApplicationEmploymentDto */
export interface RentalApplicationEmploymentDto {
  id: string;
  name?: string;
  phone?: string;
  /** @format double */
  salary?: number;
  jobTitle?: string;
  /** @format date */
  startDate?: string;
  /** @format date */
  endDate?: string;
  comment?: string;
  files: RentalApplicationFileDto[];
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** RentalApplicationEmploymentUpsertDto */
export interface RentalApplicationEmploymentUpsertDto {
  /**
   * @minLength 0
   * @maxLength 250
   */
  name?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /** @format double */
  salary?: number;
  /**
   * @minLength 0
   * @maxLength 250
   */
  jobTitle?: string;
  /** @format date */
  startDate?: string;
  /** @format date */
  endDate?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  comment?: string;
}

/** RentalApplicationFileDetailsDto */
export interface RentalApplicationFileDetailsDto {
  id: string;
  fileId: string;
  name: string;
  description?: string;
  kind: RentalApplicationFileKind;
  employmentId?: string;
  residentialHistoryId?: string;
  extension: string;
  /** @format int32 */
  size: number;
  contentType: string;
  publicUrl: RentalApplicationFileUrlDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** RentalApplicationFileDto */
export interface RentalApplicationFileDto {
  id: string;
  fileId: string;
  name: string;
  description?: string;
  kind: RentalApplicationFileKind;
  employmentId?: string;
  residentialHistoryId?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** RentalApplicationFileUrlDto */
export interface RentalApplicationFileUrlDto {
  base: string;
  raw: string;
  variantTemplate: string;
  /** @format date-time */
  expires?: string;
}

/** RentalApplicationInterestCreateDto */
export interface RentalApplicationInterestCreateDto {
  /** @minLength 1 */
  unitId: string;
}

/** RentalApplicationInterestDto */
export interface RentalApplicationInterestDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
}

/** RentalApplicationListDto */
export interface RentalApplicationListDto {
  id: string;
  companyId: string;
  status: ApplicationStatus;
  /** @format date-time */
  submittedAt?: string;
  decision: ApplicationDecision;
  isQualifiedDraft: boolean;
  /** @format int32 */
  aiApplicationScore?: number;
  screeningSummary: RentalApplicationScreeningSummary;
  stage: RentalApplicationStage;
  /** @format int32 */
  daysInStage: number;
  needs: NeedsDto;
  paymentStatus?: PaymentStatus;
  groupId?: string;
  tenantId?: string;
  leaseId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  /** @format date */
  desiredMoveInDate?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** RentalApplicationListDtoPaginationDto */
export interface RentalApplicationListDtoPaginationDto {
  items: RentalApplicationListDto[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
}

/** RentalApplicationPaymentBreakdownDto */
export interface RentalApplicationPaymentBreakdownDto {
  /**
   * Application fee
   * @format double
   */
  applicationFee: number;
  /**
   * Payment processor processing fees (2.9% + $0.30)
   * @format double
   */
  processingFees: number;
  /**
   * Total amount charged to applicant (includes processing fees if applicable)
   * @format double
   */
  totalAmount: number;
  /**
   * TransUnion screening report cost
   * @format double
   */
  transUnionCost: number;
  /**
   * Net profit received by property manager after all fees and costs
   * @format double
   */
  netAmount: number;
  /** Whether property manager pays processing fees (true) or applicant pays (false) */
  propertyManagerPaysProcessingFees: boolean;
}

/** RentalApplicationPaymentDetailDto */
export interface RentalApplicationPaymentDetailDto {
  /** @format double */
  amountPaid: number;
  /** @format date-time */
  paidAt: string;
  externalProcessorType?: ExternalTransactionType;
  returned: boolean;
  distributed: boolean;
  chartOfAccountName?: string;
  bankAccountName?: string;
  internalTransactionId: string;
}

/** RentalApplicationPaymentDto */
export interface RentalApplicationPaymentDto {
  rentalApplicationId: string;
  status: PaymentStatus;
  /** @format double */
  amount: number;
  memo?: string;
  paymentBillId?: string;
  companyPaymentBillId?: string;
  disputeBillId?: string;
  details?: RentalApplicationPaymentDetailDto;
  disputed: boolean;
  /** @format date-time */
  disputedAt?: string;
  applicationPaid: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** RentalApplicationPdfDto */
export interface RentalApplicationPdfDto {
  fileId: string;
  secureUrl: string;
}

/** RentalApplicationPetDto */
export interface RentalApplicationPetDto {
  id: string;
  name?: string;
  breed?: string;
  weight?: string;
  /** @format int32 */
  age?: number;
  gender?: PetGender;
  isSpayedOrNeutered?: boolean;
  isServiceAnimal?: boolean;
  isEmotionalSupportAnimal?: boolean;
  comment?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** RentalApplicationPetUpsertDto */
export interface RentalApplicationPetUpsertDto {
  /**
   * @minLength 0
   * @maxLength 250
   */
  name?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  breed?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  weight?: string;
  /** @format int32 */
  age?: number;
  gender?: PetGender;
  isSpayedOrNeutered?: boolean;
  isServiceAnimal?: boolean;
  isEmotionalSupportAnimal?: boolean;
  /**
   * @minLength 0
   * @maxLength 500
   */
  comment?: string;
}

/** RentalApplicationQuestionItemDto */
export interface RentalApplicationQuestionItemDto {
  text: string;
  isRequired: boolean;
  isMultiSelect: boolean;
  answers: AnswerOptionDto[];
}

/** RentalApplicationReportCapabilitiesDto */
export interface RentalApplicationReportCapabilitiesDto {
  rentalApplicationId: string;
  screeningVerified: boolean;
  /** @format double */
  creditReportFee: number;
  creditReportAvailable: boolean;
  creditReportStatus: ReportStatus;
  creditPrerequisiteReports: ReportType[];
  /** @format double */
  criminalReportFee: number;
  criminalReportAvailable: boolean;
  criminalReportStatus: ReportStatus;
  criminalPrerequisiteReports: ReportType[];
  /** @format double */
  evictionReportFee: number;
  evictionReportAvailable: boolean;
  evictionReportStatus: ReportStatus;
  evictionPrerequisiteReports: ReportType[];
}

/** RentalApplicationReportDto */
export interface RentalApplicationReportDto {
  id: string;
  reportType: ReportType;
  reportCulture: string;
  reportStatus: ReportStatus;
  /** @format date-time */
  requestedAt: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** RentalApplicationResidentialHistoryDto */
export interface RentalApplicationResidentialHistoryDto {
  id: string;
  address?: AddressDto;
  landlordName?: string;
  landlordPhone?: string;
  landlordEmail?: string;
  reasonForLeaving?: string;
  /** @format double */
  rent?: number;
  /** @format date */
  moveInDate?: string;
  /** @format date */
  moveOutDate?: string;
  verificationConsent: boolean;
  verificationStatus?: LandlordVerificationStatus;
  /** @format date-time */
  verificationRequestedAt?: string;
  /** @format date-time */
  verificationCompletedAt?: string;
  verificationCode?: string;
  verificationNotes?: string;
  landlordResponseHadLatePayments?: boolean;
  landlordResponseWasEvicted?: boolean;
  landlordResponseWouldRecommendTenant?: boolean;
  verifierName?: string;
  comment?: string;
  files: RentalApplicationFileDto[];
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** RentalApplicationResidentialHistoryUpsertDto */
export interface RentalApplicationResidentialHistoryUpsertDto {
  address?: AddressDto;
  /**
   * @minLength 0
   * @maxLength 250
   */
  landlordName?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  landlordPhone?: string;
  /**
   * A strict email address.
   * @minLength 3
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  landlordEmail?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  reasonForLeaving?: string;
  /** @format double */
  rent?: number;
  /** @format date */
  moveInDate?: string;
  /** @format date */
  moveOutDate?: string;
  verificationConsent: boolean;
  verificationStatus?: LandlordVerificationStatus;
  /** @format date-time */
  verificationRequestedAt?: string;
  /** @format date-time */
  verificationCompletedAt?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  verificationCode?: string;
  /**
   * @minLength 0
   * @maxLength 2500
   */
  verificationNotes?: string;
  landlordResponseHadLatePayments?: boolean;
  landlordResponseWasEvicted?: boolean;
  landlordResponseWouldRecommendTenant?: boolean;
  /**
   * @minLength 0
   * @maxLength 500
   */
  comment?: string;
}

/** RentalApplicationScreeningDto */
export interface RentalApplicationScreeningDto {
  rentalApplicationId: string;
  /** @format int32 */
  transunionScreeningRequestId?: number;
  /** @format int32 */
  transunionScreeningRequestRenterId?: number;
  verificationStatus: VerificationStatus;
  skipped: boolean;
  skippedBy?: string;
  /** @format date-time */
  skippedAt?: string;
  /** @format double */
  creditUtilization?: number;
  /** @format int32 */
  creditScore?: number;
  canRevalidate: boolean;
  revalidationBlockedReason?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** ReportStatusWebhookPayload */
export interface ReportStatusWebhookPayload {
  /** @format int32 */
  screeningRequestRenterId: number;
  reportType: string;
  status: string;
  culture?: string;
}

/** RequestApplicantCompleteScreeningReadinessDto */
export interface RequestApplicantCompleteScreeningReadinessDto {
  allowed: boolean;
  screeningNotRequired: boolean;
  requiresSubmitted: boolean;
  alreadyScreened: boolean;
  missingFields: string[];
}

/** RequestReportsDto */
export interface RequestReportsDto {
  reportTypes: string[];
  approvedReportsAlreadyExists: boolean;
}

/** SendRentalApplicationToOwnerRequestDto */
export interface SendRentalApplicationToOwnerRequestDto {
  /** @minItems 1 */
  ownerIds: string[];
  subject?: string;
  body?: string;
}

/** SendRentalApplicationToOwnerResultDto */
export interface SendRentalApplicationToOwnerResultDto {
  fileId: string;
  sentOwnerIds: string[];
  skippedOwnerIds: string[];
}

/** SetDecisionDto */
export interface SetDecisionDto {
  decision: ApplicationDecision;
}

/** SubmitAnswerEntryDto */
export interface SubmitAnswerEntryDto {
  /**
   * @minLength 1
   * @maxLength 500
   */
  path: string;
  isSelected: boolean;
  /**
   * @minLength 0
   * @maxLength 500
   */
  freeformValue?: string;
}

/** SubmitAnswersDto */
export interface SubmitAnswersDto {
  answers: SubmitAnswerEntryDto[];
}

/** SubmitRentalApplicationResult */
export interface SubmitRentalApplicationResult {
  success: boolean;
  errors: string[];
}

/** TruliaSyndicationStatusDto */
export interface TruliaSyndicationStatusDto {
  status: SyndicationStatus;
  url?: string;
}

/** UnitListingSyndicationStatusDto */
export interface UnitListingSyndicationStatusDto {
  zillowStatus?: ZillowSyndicationStatusDto;
  hotpadsStatus?: HotpadsSyndicationStatusDto;
  truliaStatus?: TruliaSyndicationStatusDto;
}

/** UpdateRentalApplicationDto */
export interface UpdateRentalApplicationDto {
  /**
   * @minLength 0
   * @maxLength 250
   */
  firstName?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  lastName?: string;
  /**
   * A strict email address.
   * @minLength 3
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  permissionToTexting?: boolean;
  /**
   * @minLength 0
   * @maxLength 100
   */
  ssn?: string;
  /** @format date */
  dateOfBirth?: string;
  /** @format date */
  desiredMoveInDate?: string;
  maritalStatus?: MaritalStatus;
  driversLicense?: DriversLicenseDto;
  incomeInformation?: IncomeInformationDto;
  emergencyContact?: RentalApplicationEmergencyContactDto;
}

/** VelocityDeltasDto */
export interface VelocityDeltasDto {
  /** @format double */
  avgTimeToDecisionDays?: number;
  /** @format double */
  approvalRate30d?: number;
  /** @format int32 */
  convertedThisMonth?: number;
  /** @format int32 */
  feesCollectedMtdCents?: number;
}

/** VelocityDto */
export interface VelocityDto {
  /** @format double */
  avgTimeToDecisionDays: number;
  /** @format double */
  approvalRate30d: number;
  /** @format int32 */
  convertedThisMonth: number;
  /** @format int32 */
  feesCollectedMtdCents: number;
  deltas?: VelocityDeltasDto;
}

/** ZillowSyndicationStatusDto */
export interface ZillowSyndicationStatusDto {
  status: SyndicationStatus;
  url?: string;
}

export interface SyndicateRentmorParams {
  /**
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * @format int32
   * @default 10
   */
  limit?: number;
  propertyType?: string;
  /** @format double */
  bedsMin?: number;
  /** @format double */
  bedsMax?: number;
  /** @format double */
  bathsMin?: number;
  /** @format double */
  bathsMax?: number;
  /** @format int32 */
  sizeMin?: number;
  /** @format int32 */
  sizeMax?: number;
  /** @format double */
  priceMin?: number;
  /** @format double */
  priceMax?: number;
  /** @format double */
  depositMin?: number;
  /** @format double */
  depositMax?: number;
  petsAllowed?: boolean;
  streetNumber?: string;
  streetName?: string;
  neighborhood?: string;
  postalCode?: string;
  zip?: string;
  city?: string;
  state?: string;
}

export interface SyndicateRentmorByPropertyIdParams {
  /** @format int64 */
  propertyId: string;
}

export interface AddParams {
  applicationId: string;
}

export interface UpdateParams {
  applicationId: string;
  id: string;
}

export interface DeleteParams {
  applicationId: string;
  id: string;
}

export interface InviteParams {
  applicationId: string;
}

export interface RemoveParams {
  applicationId: string;
  coApplicantId: string;
}

export interface Add2Params {
  applicationId: string;
}

export interface Update2Params {
  applicationId: string;
  id: string;
}

export interface Delete2Params {
  applicationId: string;
  id: string;
}

export interface Add3Params {
  applicationId: string;
}

export interface Update3Params {
  applicationId: string;
  id: string;
}

export interface Delete3Params {
  applicationId: string;
  id: string;
}

export interface CreateSessionParams {
  applicationId: string;
}

export interface CommitSessionParams {
  applicationId: string;
  sessionId: string;
}

export interface GetFileParams {
  applicationId: string;
  id: string;
}

export interface Delete4Params {
  applicationId: string;
  id: string;
}

export interface Add4Params {
  applicationId: string;
}

export interface Delete5Params {
  applicationId: string;
  id: string;
}

export interface SkipParams {
  applicationId: string;
}

export interface RecordOfflineParams {
  applicationId: string;
}

export interface RefundParams {
  applicationId: string;
}

export interface Add5Params {
  applicationId: string;
}

export interface Update4Params {
  applicationId: string;
  id: string;
}

export interface Delete6Params {
  applicationId: string;
  id: string;
}

export interface SubmitAnswersParams {
  applicationId: string;
}

export interface Add6Params {
  applicationId: string;
}

export interface Update5Params {
  applicationId: string;
  id: string;
}

export interface Delete7Params {
  applicationId: string;
  id: string;
}

export interface RequestVerificationParams {
  applicationId: string;
  residentialHistoryId: string;
}

export interface ResendVerificationParams {
  applicationId: string;
  residentialHistoryId: string;
}

export interface GetRentalApplicationsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  stages?: string[];
  stage?: string;
  decisions?: ApplicationDecision[];
  needs?: string;
  screeningVerified?: boolean;
  excludeRetracted?: boolean;
  sort?: string;
  portfolioIds?: string[];
  propertyIds?: string[];
  unitIds?: string[];
  newOnly?: boolean;
}

export interface GetRentalApplicationParams {
  id: string;
}

export interface UpdateRentalApplicationParams {
  id: string;
}

export interface DeleteRentalApplicationParams {
  id: string;
}

export interface GenerateRentalApplicationPdfParams {
  /** @format int64 */
  id: string;
}

export interface SendRentalApplicationToOwnerParams {
  id: string;
}

export interface SubmitRentalApplicationParams {
  id: string;
}

export interface RescoreRentalApplicationParams {
  id: string;
}

export interface RetractRentalApplicationParams {
  id: string;
}

export interface SetDecisionParams {
  id: string;
}

export interface CreateInfoUpdateRequestParams {
  id: string;
}

export interface GetInfoUpdateRequestsParams {
  id: string;
}

export interface ResendInfoUpdateRequestParams {
  /** @format int64 */
  id: string;
  /** @format int64 */
  infoUpdateRequestId: string;
}

export interface GetGenieTakeParams {
  id: string;
}

export interface ConvertToTenantParams {
  id: string;
}

export interface SendReminderParams {
  id: string;
}

export interface AcceptBifurcatedScreeningParams {
  /** @format int64 */
  id: string;
}

export interface Skip2Params {
  applicationId: string;
}

export interface RequestApplicantCompleteParams {
  applicationId: string;
}

export interface RevalidateParams {
  applicationId: string;
}

export interface RequestReportsParams {
  applicationId: string;
}

export interface GetReportsParams {
  applicationId: string;
}

export interface GetReportParams {
  applicationId: string;
  reportId: string;
}

export interface GetReportCapabilitiesParams {
  applicationId: string;
}

export interface GetUnitListingSyndicationStatusParams {
  /** @format int64 */
  unitId: string;
}

export interface ValidateUnitListingSyndicationParams {
  /** @format int64 */
  unitId: string;
}
